import { IconButton, Popover, Typography } from "@mui/material"
import { useTranslations } from "next-intl"
import InfoCircle from "ui/icons/InfoCircle"

import styled from "@emotion/styled"
import { useState } from "react"
import Close from "ui/icons/Close"

const StyledIconButton = styled(IconButton)`
  align-self: center;
  padding: 0;
`

const StyledPopover = styled(Popover)`
  box-shadow: none;
  & .MuiPaper-root {
    box-shadow: none;
    display: flex;
    width: 291px;
    padding: 12px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    gap: 12px;
    border-radius: 8px;
    background: var(--white, #fff);
    box-shadow: 0px 4px 24px 0px rgba(5, 23, 17, 0.16);
  }
`

const TopText = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 4px;
`
export default function InfoPopup({ type }: { type: "fine" | "form" }) {
  const t = useTranslations("Forms")
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? "simple-popover" : undefined
  return (
    <>
      <StyledIconButton
        aria-describedby={id}
        onClick={handleClick}
        aria-label="מידע נוסף"
      >
        <InfoCircle />
      </StyledIconButton>
      <StyledPopover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "center",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "left",
        }}
      >
        <TopText>
          <IconButton onClick={handleClose} aria-label="סגור מידע נוסף">
            <Close />
          </IconButton>
        </TopText>
        <Typography variant="body3">
          {type === "fine" ? t("reportNumIs") : t("formNumIs")}
        </Typography>
      </StyledPopover>
    </>
  )
}
